/** 用户管理API */
import type { Api } from '@/typings/api';
import { download, post, upload } from '../../request';
const prefix = '/sys/account';
/**
 * 分页查询
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Sys.Account> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询系统配置-用户信息列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Sys.Account> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个用户
 *
 * @param id 用户ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Sys.Account> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存用户
 *
 * @param params 用户信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新用户信息
 *
 * @param params 用户信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除用户
 *
 * @param id 用户ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除用户
 *
 * @param ids 用户ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};
/**
 * 修改密码
 *
 * @param params 修改密码
 * @returns
 */
export const updatePassword: Api.CommonMethods.Update = ({ oldPassword, newPassword, id }) => {
  return post(`${prefix}/updatePassword`, { oldPassword, newPassword, id });
};

/** 新增会员 */
export const saveMember = (account: Api.Sys.Account) => {
  return post(`${prefix}/saveMember`, account);
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams, fileName?: string) => {
  return download(`${prefix}/export`, params, fileName);
};

/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
